import { customerDivisionsSlice } from "./customerDivisionsSlice";
import * as actions from "./customerDivisionsActions";
import * as selectors from "./customerDivisionsSelectors";

export { actions };
export { selectors };
export default customerDivisionsSlice.reducer;
